import { render, staticRenderFns } from "./speech.vue?vue&type=template&id=779752d2&scoped=true&"
import script from "./speech.vue?vue&type=script&lang=js&"
export * from "./speech.vue?vue&type=script&lang=js&"
import style0 from "./speech.vue?vue&type=style&index=0&id=779752d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779752d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779752d2')) {
      api.createRecord('779752d2', component.options)
    } else {
      api.reload('779752d2', component.options)
    }
    module.hot.accept("./speech.vue?vue&type=template&id=779752d2&scoped=true&", function () {
      api.rerender('779752d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonSpeech/speech.vue"
export default component.exports